/* eslint-disable react-hooks/exhaustive-deps */
import { Flex, keyframes } from "@chakra-ui/react";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as WarningIcon } from "./warning-circular.svg";

export function ErrorIndicator() {
  const opacityAnim = keyframes`
      0%, 27% {
      opacity: 0;
      };
      40%, 85% {
      opacity: 1;
      }
      100% {
      opacity: 0;
      }
      `;

  return (
    <Flex
      bg="warningBase"
      width="26px"
      justifyContent="center"
      alignItems="center"
      height="26px"
      zIndex="1"
      borderRadius="100%"
      position="absolute"
      top="11px"
      left="4px"
      opacity="0"
      animation={`2.2s ${opacityAnim} linear infinite`}
    >
      <SvgContainer icon={WarningIcon} fill="white" size="22px" />
    </Flex>
  );
}
